export const SUPPORTED_CHAINS = [42];

export const SORT_CRITERIA = {
  AToZ: 'name:asc',
  ZToA: 'name:desc',
  LowestPrice: 'price:asc',
  HighestPrice: 'price:desc',
  Latest: 'created:desc',
  Oldest: 'created:asc',
};

export const TAB_NAMES = {
  AllIngredients: 'All Ingredients',
  Farmers: 'Farmers',
  Specials: 'Specials',
};
